<template lang="pug">
BriqDialog(@close="$emit('close')")
  h2.pb-XS Select other customer
  label.input-label.type-bold Customer *
  FindCustomerInput(@selected="selected" ref="findCustomer" @lastSearchQuery="setLastSearchQuery")
  .flex.justify-center.mt-M
    BriqButton.mr-XS(variant="secondary" @click="$emit('close')") Cancel
    BriqSubmitButton(@click="changeCustomerOnBooking" :disabled="isSaving" :pending="isSaving") Change customer
</template>

<script>
import FindCustomerInput from '@/vue/components/FindCustomerInput.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import { reduce, map } from 'ramda'

export default {
  name: 'SelectOtherCustomerDialog',
  components: { FindCustomerInput },
  props: {
    customerKey: String,
  },
  data() {
    return {
      lastSearchQuery: '',
      newCustomer: null,
      isSaving: false,
    }
  },
  computed: {
    ...mapState('bookingDetails', ['saveError']),
    ...mapGetters('bookingDetails', ['customers']),
    bookingCustomers() {
      return reduce((agg, next) => {
        return [...agg, { CustomerKey: next.Key, Email: next.Email, Role: next.Role }]
      }, [])(this.customers)
    },
  },
  methods: {
    ...mapActions('bookingDetails', ['changeCustomer']),
    setNewMainBooker(bookingCustomers, mainBooker) {
      return map(x => {
        if (x.Role === 'MainBooker') return mainBooker
        else return x
      }, bookingCustomers)
    },
    setLastSearchQuery(searchQuery) {
      this.lastSearchQuery = searchQuery
    },
    selected(customer) {
      this.newCustomer = customer
    },
    async changeCustomerOnBooking() {
      if (!this.newCustomer) {
        this.$notifyWarning('Select customer first!')
        return
      }
      this.isSaving = true
      const newMainBookerCustomer = {
        CustomerKey: this.newCustomer.Key,
        Email: this.newCustomer.Email,
        Role: 'MainBooker',
      }
      const customersDetails = this.setNewMainBooker(this.bookingCustomers, newMainBookerCustomer)
      const success = await this.changeCustomer(customersDetails)
      if (success) {
        this.$notifySuccess('Customer changed')
        this.$emit('close')
      } else {
        this.$handleError({
          error: this.saveError,
          notification: 'Something went wrong while adding new customer',
        })
      }
      this.isSaving = false
    },
  },
}
</script>

<style scoped lang="stylus"></style>
